import { defineStore } from 'pinia'
import { fetchMessageCount } from '@ms/api/message'
import fetchBff from 'crypto-fetch/bff'
import { useUserStore } from './index'

// user 状态数据
export const useUserStatsStore = defineStore('userStats', {
  state: () => ({
    // 用户进行中的 offer 数量
    offerCount: 0,
    // 新红包数量
    newVoucherCount: 0,
    // 站内信未读数量接口
    messageCount: 0
  }),
  actions: {
    initFetch() {
      const bffApiList = [
        {
          uri: '/marketing/market/offer/count',
          callback: (count) => {
            this.offerCount = count
          }
        },
        {
          uri: '/marketing/market/voucher/new-count',
          callback: (count) => {
            this.newVoucherCount = count
          }
        },
        {
          uri: '/msg/site/info/count',
          parameters: {
            commentaryType: 3
          },
          callback: (count) => {
            this.messageCount = count
          }
        },
        {
          uri: '/pocket/financialAccounts/balance',
          callback: (data) => {
            useUserStore().updateBalance(data.avlBal)
          }
        }
      ]

      fetchBff(bffApiList).catch(console.error)
    },
    /**
     * 查询站内信未读数量接口
     */
    async getNewMessage() {
      const { error, data } = await fetchMessageCount(3)
      if (!error) {
        this.messageCount = data
      }
    }
  }
})
